import { render, staticRenderFns } from "./ShowEdit.vue?vue&type=template&id=54856b57&"
import script from "./ShowEdit.vue?vue&type=script&lang=js&"
export * from "./ShowEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54856b57')) {
      api.createRecord('54856b57', component.options)
    } else {
      api.reload('54856b57', component.options)
    }
    module.hot.accept("./ShowEdit.vue?vue&type=template&id=54856b57&", function () {
      api.rerender('54856b57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShowEdit.vue"
export default component.exports